import Backbone from '@polleverywhere/backbone'

export default class Archive extends Backbone.Model {
  localeName (timeZone) {
    if (this.get('created_at')) {
      const created = new Date(this.get('created_at'))
      try {
        const newDateString = created.toLocaleDateString('en-US', {
          timeZone
        })
        const newTimeString = created.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          timeZone
        })
        return `${newDateString} ${newTimeString}`
      } catch (error) {
        return `${created.toDateString()} ${created.toTimeString({ hour: '2-digit', minute: '2-digit' })}`
      }
    } else {
      return this.get('name')
    }
  }
}
